import React from "react";
import { Helmet } from "react-helmet";
import DefaultLayout from "../../layouts/DefaultLayout";
import SignUpForm from "./SignUp/SignUpForm";
import { useLocation, useParams } from "react-router-dom";
import { APPLICATION_SOURCE } from "@booyaltd/core";

// Giftcard codes are 16+ chars of [a-zA-Z0-9-_]. The route's v5 pattern
// (":code([a-zA-Z0-9-_]{16,})?") enforced this in the path itself; v6
// dropped regex params (#637), and because the param is OPTIONAL a failing
// value must mean "no code", not a 404 — so the check lives here.
const GIFTCARD_CODE_PATTERN = /^[a-zA-Z0-9-_]{16,}$/;

export default function Giftcard() {
  const location = useLocation();
  const { code: rawCode } = useParams<{ code?: string }>();
  const code =
    rawCode && GIFTCARD_CODE_PATTERN.test(rawCode) ? rawCode : undefined;
  return (
    <DefaultLayout showTry={false} showSignIn={false}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>FarmFLiX.tv | Redeem FarmFLiX Giftcard Now</title>
        <meta
          name="description"
          content="Got a FarmFLiX Giftcard? New Member? Redeem it here to get started.  Existing Member? Redeem to top up your membership now."
        />
      </Helmet>
      <SignUpForm
        route={undefined}
        source={APPLICATION_SOURCE.GIFTCARD}
        code={code}
        page={location.pathname}
        title="Redeem a Giftcard"
      />
    </DefaultLayout>
  );
}
